import { LinkInfo, PagingHeader } from '../shared/shared.model';
import { ImportMaps } from '../models/importmaps.model';
export class DataOutputModelCalc {
  Paging: PagingHeader;
  Links: LinkInfo[];
  Items: OpdataCalc[];
}

export class OpdataImport {
  TrainId: string;
  AspNetUsersId: string;
  ImportOption: string;
  Worksheet: number;
  HeaderRow: number;
  importErrors: string;
  ColumnMaps: ColMapping[];
  importMap: ImportMaps;
}

export class ColMapping {
  key: string;
  value: string;
}

export interface OpdataCalc {
  Id: number;
  TrainId: number;
  Datetime: string;
  Ph: number;
  FeedTemp: number;
  TcfWater: number;
  TcfSalt: number;
  S1FeedFlow: number;
  S1PermFlow: number;
  S1ConcFlow: number;
  S1PermCond: number;
  S1Recovery: number;
  S1FeedTds: number;
  S1Flux: number;
  S1DiffPressure: number;
  Temp: number;
  S1AvgFeedTds: number;
  S1PermTds: number;
  S1Cpf: number;
  S1Aftds: number;
  S1AvgFeedOp: number;
  S1Pop: number;
  S1NetDrivePressure: number;
  S1AVal: number;
  S1BVal: number;
  S1Npf: number;
  S1Nsp: number;
  S1NormDiffPress: number;
  S2FeedFlow: number;
  S2PermeateFlow: number;
  S2Recovery: number;
  S2Flux: number;
  S2DiffPressure: number;
  S2Tmp: number;
  S2FeedTds: number;
  S2PermTds: number;
  S2Cpf: number;
  S2Aftds: number;
  S2AvgFeedOp: number;
  S2Pop: number;
  S2NetDrivPress: number;
  S2AVal: number;
  S2BVal: number;
  S2Npf: number;
  S2Nsp: number;
  S2NormDiffPress: number;
  S3FeedFlow: number;
  S3PermeateFlow: number;
  S3ConcentrateFlow: number;
  S3PermConductivity: number;
  S3Recovery: number;
  S3Flux: number;
  S3DiffPressure: number;
  S3Tmp: number;
  S3FeedTds: number;
  S3PermTds: number;
  S3Cpf: number;
  S3AvgFeedTds: number;
  S3AvgFeedOp: number;
  S3Pop: number;
  S3NetDrivPress: number;
  S3AVal: number;
  S3BVal: number;
  S3Npf: number;
  S3Nsp: number;
  S3NormDiffPress: number;
  TotalFeedFlow: number;
  TotalPermFlow: number;
  TotalConcFlow: number;
  TotalPermCond: number;
  TotalRecovery: number;
  TotalFlux: number;
  TotalDiffPressure: number;
  TotalTmp: number;
  TotalFeedTds: number;
  TotalPermTds: number;
  TotalCpf: number;
  TotalAvgFeedTds: number;
  TotalAvgFeedOp: number;
  TotalPop: number;
  TotalNetDrivPress: number;
  TotalAVal: number;
  TotalBVal: number;
  TotalNpf: number;
  TotalNsp: number;
  TotalNormDiffPress: number;
  CreatedAt: number;
  UpdatedAt: number;
  OpdatId: number;
  ActionType: number;
  Comments: number;
  TotalConcPress: number;
  TotalDp: number;
  TotalFeedCond: number;
  TotalFeedPress: number;
  TotalMa: number;
  TotalPermOp: number;
  TotalPermPress: number;
  Valid: number;
  TotalTcfWater: number;
  TotalTcfSalt: number;
  AspNetUsersId: string;
  Ud1: number;
  Ud2: number;
  Ud3: number;
  Ud4: number;
  Ud5: number;
}
